import BaseService from "./BaseService.js";

class RiskService extends BaseService {
  getEvents({ params = {}, id, signal }) {
    return this.apiGet({
      url: `/scl/${id}/linked-events`,
      params,
      signal,
    });
  }
}

export default new RiskService();

